import React from 'react';
import { TwoOptionSelect, Input } from '@blueprintnyc/bpnyc-common';
import ColorInput from 'components/ColorInput';
import LinkPicker from 'components/LinkOmniPicker/LinkPicker';
import ImageUpload from 'components/ImageUpload';
import config from 'config';

const ButtonItemOptions = ({
	button,
	index,
	event,
	updateButton,
	updateButtonField,
	setOmniPicker,
	handlePickOmniItem,
}) => {
	const {
		onPress = {},
		buttonColor = '#AAAAAA',
		textColor = '#FFFFFF',
		size,
		position,
		text,
		source,
	} = button || {};
	const signedUrlEndpoint = `${config.baseUrl}/${event.client_id}/events/${event.id}/upload/media/signed_url`;

	return (
		<div>
			<div>
				<h4 className="admin-form-item-label">Button {index + 1} Text</h4>
				<Input value={text} onChange={value => updateButtonField(index, 'text', value)} />
			</div>

			<h4 className="admin-form-item-label">Button {index + 1} Link</h4>
			<LinkPicker
				onClick={() =>
					setOmniPicker({ open: true, mediaPicker: false, from: 'link', index, onPress })
				}
				onPress={onPress}
				placeholderStr={'Select Link Target'}
				onConfirm={() => handlePickOmniItem({}, index)}
			/>
			<div className="ColorPickers">
				<div>
					<h4 className="admin-form-item-label">Background Color</h4>
					<ColorInput
						color={buttonColor}
						onChange={hex => updateButtonField(index, 'buttonColor', hex)}
						eventID={event.id}
					/>
				</div>
				<div>
					<h4 className="admin-form-item-label">Text Color</h4>

					<ColorInput
						color={textColor}
						onChange={hex => updateButtonField(index, 'textColor', hex)}
						eventID={event.id}
					/>
				</div>
			</div>
			<div className="same-row">
				<div>
					<h4 className="admin-form-item-label">Upload an Icon</h4>
					<ImageUpload
						endpoint={signedUrlEndpoint}
						value={source?.src || ''}
						onChange={nextSource => updateButtonField(index, 'source', nextSource)}
						imageObj={true}
					/>
				</div>
				<div>
					<h4 className="admin-form-item-label">Text Size</h4>
					<TwoOptionSelect
						selected={size !== 'large'}
						onChange={val => updateButtonField(index, 'size', val ? 'default' : 'large')}
						yesLabel="Default"
						noLabel="Large"
					/>
					<h4 className="admin-form-item-label">Icon Position (optional)</h4>
					<TwoOptionSelect
						selected={position !== 'right'}
						onChange={val => updateButton(index, { position: val ? 'left' : 'right' })}
						yesLabel="Left"
						noLabel="Right"
					/>
				</div>
			</div>
		</div>
	);
};

export default ButtonItemOptions;
